<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 3)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
        </div> 
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="zhe" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/zhe.png">

        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/walk/0.png">
        <!-- <img id="partner" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/clap/0.png"> -->
        <!-- <img id="partner" src="@/assets/game2-10/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="talkAudio" preload="auto">
          <source :src="this.talkAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.talkAudioVoice = new Howl({
      src: [this.talkAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.walkAudioVoice.pause()
    this.talkAudioVoice.pause()
  },
  data() {
    return {
      walkAudioVoice: null,
      talkAudioVoice: null,
      personTarget: {
        top: null,
        right: null
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/sounds/walk.mp3`,
      talkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/sounds/talk.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 1, // 花苞
      talkImgLength: 30, // 蚂蚁交流
      workImgLength: 54, // 小人走路动画
      digImgLength: 105
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.right', person.style.right, this.personTarget.right)
          if (!person.style.right || person.style.right.slice(0,-2) == this.personTarget.right) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      if (this.isVertical) {
        this.personTarget.top = personTarget.offsetTop
        this.personTarget.right = document.body.clientHeight - personTarget.offsetLeft - personTarget.offsetWidth
      } else {
        this.personTarget.top = personTarget.offsetTop
        this.personTarget.right = document.body.clientWidth - personTarget.offsetLeft - personTarget.offsetWidth
      }     
    },
    // 走路动画
    personWalkGifHandler (word, index) {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = 0
      const person = document.getElementById('person')
      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i === this.talkImgLength) {
          // document.getElementById('walkAudio').play()
          // this.walkAudioVoice.pause()
          this.walkAudioVoice.play()
          this.animeWalk(word, index)
        }
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          // this.isWalk = false
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/walk/${i}.png`
        }
      }, 95)
    },
    animeWalk(word, index) {
      const target = document.getElementById(`word${index}`)
      const person = document.getElementById('person')
      const zhe = document.getElementById('zhe')
       // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/${1}.png`
      const iconTarget = document.querySelector(`#word${index} .icon`)
      // flowerTarget.style.zIndex = '90'
      console.log('isVertical', this.isVertical, target.offsetTop)
      
      this.animation = anime({
        targets: person,
        right: this.isVertical ? `${document.body.clientHeight - target.offsetLeft - target.offsetWidth/2 - person.offsetWidth/2}px` : `${document.body.clientWidth - target.offsetLeft - target.offsetWidth/2 - person.offsetWidth/2}px`,
        top: `${target.offsetTop-target.offsetHeight}px`,
        easing: 'easeInOutQuad',
        duration: (this.workImgLength-this.talkImgLength)*95, // 走路多久到达的时间 走路的动作乘以时间
        complete: () => {
          // target.innerHTML = '到达'
          iconTarget.style.display = 'none'
          flowerTarget.style.display = 'none'
          clearInterval(this.timerWalk)
         
          this.personDigGifHandler(`word${index}`)
          // document.getElementById('walkAudio').play()
          // this.walkAudioVoice.pause()
          this.walkAudioVoice.play()
          this.animation2 = anime({
            targets: person,
            // document.body.clientWidth
            right: `${this.isVertical ? document.body.clientHeight*0.03 : document.body.clientWidth*0.03}px`,
            top: `${-person.offsetHeight*0.01}`,
            // top: `${this.personTarget.top * 0.9}px`,
            easing: 'easeInOutQuad',
            duration: (this.digImgLength-this.workImgLength-1-5) * 70, // 走路多久到达的时间 走路的动作乘以时间
            changeComplete: function() {
              // person.style.opacity = '0'
            }, 
            complete: () => {
              this.animation3 = anime({
                targets: person,
                // document.body.clientWidth
                right: `${-person.offsetWidth}px`,
                // top: `${this.personTarget.top * 0.9}px`,
                easing: 'easeInOutQuad',
                duration: (5) * 200, // 走路多久到达的时间 走路的动作乘以时间
                changeComplete: function() {
                  person.style.opacity = '0'
                }, 
                complete: () => {
                  this.delayTimer = setTimeout(() => {
                      person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/walk/${0}.png`
                      zhe.style.display = 'none'
                      person.style.left = null
                      person.style.bottom = null
                      person.style.top = `${this.personTarget.top}px`
                      person.style.right = `${this.personTarget.right}px`  
                      person.style.display = 'block'  
                      person.style.opacity = '100'    
                      this.showWordList[index].clicked = false
                      // 下一个字包括音效 
                      this.getData(true)  
                  }, 1000)    
                }
              }) 
            }
          })
          
          
        }
      });
    },
    // 挖宝动画
    personDigGifHandler () {
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.workImgLength
      const person = document.getElementById('person')
      const zhe = document.getElementById('zhe')

      this.timerDig = setInterval(() => {
        this.isWalk = true
        if (i==this.digImgLength-6) {
          zhe.style.display = 'block'
        }
        if (i >= this.digImgLength -1) {
          clearInterval(this.timerDig)
          this.timerDig = null
          // this.isWalk = false
          // person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/walk/${0}.png`
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/walk/${i}.png`
        }
      }, 70)
    },
    // 面板动画
    boardGifHandler (id, index) {
      clearInterval(this.timerBoard)
      this.timerBoard = null
     
      const animeType = this.animeTypes
      let i = 0
      const wordTarget = document.querySelector(`#${id} div`)
      wordTarget.style.display = 'none'
      

      const target = document.querySelector(`#${id} .flower`)
      this.timerBoard = setInterval(() => {
        this.isWalk = true
        if (i>=this.boardImgLength-1) {
          clearInterval(this.timerBoard)
          this.timerBoard = null
          // 隐藏花
          target.style.display = 'none'
          // word.style.visibility = 'hidden'

          this.isWalk = false
          this.showWordList[index].clicked = false
          // 下一个字包括音效 
          this.getData(true)
        } else {
          i=i+1
          target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type${animeType}/${i}.png`
          // target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type${animeType}/${i}.png`
        }
      }, 85)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        const person = document.getElementById('person')
        person.style.left = null
        person.style.bottom = null
        person.style.top = `${this.personTarget.top}px`
        person.style.right = `${this.personTarget.right}px`
        
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.zIndex = '60'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.zIndex = '60'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        return false
      }
      this.showWordList[index].clicked = true

      this.playClickAudio()

      // document.getElementById('talkAudio').play()
      this.talkAudioVoice.play()
      this.personWalkGifHandler(word, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game2-10/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}
.box {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;

}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  &:nth-of-type(1) {
    display: flex;
    height: 20%;
    margin-top: 50vw;
    // position: fixed;
    // bottom: 120px;
    margin-left: 8%;
  }
  &:nth-of-type(2) {
    margin-top: 10px;
    margin-left: 8%;
    height: 20%;
    // position: fixed;
    // bottom: 20px;
    // left: 10%;
  }
  .word {
    transform-origin: center;
    width: 130px;
    height: 88px;
    // height: 88px;
    font-size: 30px;
    // font-weight: bolder;
    position: relative;
    .flower {
      position: absolute;
      width: 95%;
      left: 0;
      height: 100%;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: 20px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 60px;
      height: 60px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 9%;
    }
  }
}
.home-horizontal {
  .word-container {
    &:nth-of-type(1) {
      // margin-left: 120px;
      margin-top:50vh;
    }
  }
}
#zhe {
  display: none;
  height: 44.32%;
  width: 17.72%;
  position: fixed;
  right: 0%;
  top: 0;
  z-index: 80;
}
#person {
  width: 245px;
  height: 46%;
  // height: 150px;
  position: fixed;
  right: 13%;
  top: 4%;
  z-index: 40;
}
#partner {
  width: 154.16px;
  height: 198.16px;
  position: fixed;
  top: 20px;
  right: 40px;
}
}
</style>